import { Component } from '@angular/core';

@Component({
  selector: 'zbp-loading-placeholder',
  templateUrl: './loading-placeholder.component.html',
  styleUrls: ['./loading-placeholder.component.scss']
})
export class LoadingPlaceholderComponent {
}
